import React from 'react';
import { useNode } from '@craftjs/core';
import { useTheme } from '../../../contexts/ThemeContext';

export const DividerBlock = ({ style, spacing }) => {
  const { isDark } = useTheme();
  const { connectors: { connect, drag }, selected } = useNode((state) => ({
    selected: state.events.selected
  }));

  const styles = {
    solid: 'border-t',
    dashed: 'border-t border-dashed',
    dotted: 'border-t border-dotted',
    space: 'border-none'
  };

  return (
    <div
      ref={(ref) => ref && connect(drag(ref))}
      className={`rounded-lg transition-all ${
        selected ? 'ring-2 ring-[#A2FF00]' : ''
      } ${isDark ? 'hover:bg-zinc-800/50' : 'hover:bg-gray-100'}`}
      style={{ padding: `${spacing || 16}px 16px` }}
    >
      <div className={`${styles[style]} ${isDark ? 'border-zinc-700' : 'border-gray-300'}`} />
    </div>
  );
};

DividerBlock.craft = {
  displayName: 'Divider',
  props: {
    style: 'solid',
    spacing: 16
  },
  related: {
    toolbar: DividerBlockSettings
  }
};

function DividerBlockSettings() {
  const { actions: { setProp }, props } = useNode((node) => ({
    props: node.data.props
  }));
  const { isDark } = useTheme();

  return (
    <div className="space-y-4">
      <div>
        <label className={`block text-sm font-medium mb-1 ${isDark ? 'text-zinc-300' : 'text-gray-700'}`}>
          Style
        </label>
        <div className="grid grid-cols-2 gap-2">
          {['solid', 'dashed', 'dotted', 'space'].map((s) => (
            <button
              key={s}
              onClick={() => setProp(props => props.style = s)}
              className={`px-3 py-2 rounded-lg border capitalize ${
                props.style === s
                  ? 'bg-[#A2FF00] text-black border-[#A2FF00]'
                  : isDark ? 'bg-zinc-800 border-zinc-700 text-white' : 'bg-white border-gray-300'
              }`}
            >
              {s}
            </button>
          ))}
        </div>
      </div>
      <div>
        <label className={`block text-sm font-medium mb-1 ${isDark ? 'text-zinc-300' : 'text-gray-700'}`}>
          Spacing: {props.spacing}px
        </label>
        <input
          type="range"
          min="8"
          max="64"
          value={props.spacing}
          onChange={(e) => setProp(props => props.spacing = parseInt(e.target.value))}
          className="w-full"
        />
      </div>
    </div>
  );
}

export { DividerBlockSettings };